// Pagination
export const paginationMenuStyling = {
    indicatorSeparator: (provided, state) => ({
        ...provided,
        display: 'none'
    }),
    container: (provided, state) => ({
        ...provided,
        width: '6em',
        height: '25px'
    }),
    control: (provided, state) => ({
        ...provided,
        minHeight: 'fit-content',
        borderColor: 'var(--border)!important',
        boxShadow: 'none',
        cursor: 'pointer',
        borderRadius: '5px',
        textAlign: 'end'
    }),
    indicatorsContainer: (provided, state) => ({
        ...provided,
        height: '25px'
    }),
    option: (provided, state) => ({
        ...provided,
        color: 'var(--primary)',
        cursor: 'pointer',
        textAlign: 'center',
    }),
    menu: (provided, state) => ({
        ...provided,
        borderRadius: '2px 2px 15px 15px',
        boxShadow: '0 4px 11px hsla(0, 0%, 0%, 0.1)'
    }),
    menuList: (provided, state) => ({
        ...provided,
        padding: '0'
    }),
}

export const paginationMenuTheme = (theme) => ({
    ...theme,
    borderRadius: 0,
    colors: {
        ...theme.colors,
        primary25: 'var(--accent)',
        primary50: 'var(--accent)',
        primary: 'transparent',
    },
})

// Groups
export const groupsMenuStyling = {
    indicatorSeparator: (provided, state) => ({
        ...provided,
        display: 'none'
    }),
    control: (provided, state) => {
        let styleObj = ({
            ...provided,
            minHeight: 'fit-content',
            borderColor: 'var(--border)!important',
            boxShadow: 'none',
            cursor: 'pointer',
            borderRadius: '5px',
            textAlign: 'end'
        })
        if (state.isDisabled) {
            styleObj = { ...styleObj, backgroundColor: 'var(--muted)' }
        }
        return styleObj;
    },
    option: (provided, state) => ({
        ...provided,
        cursor: 'pointer',
        textAlign: 'center',
        color: 'var(--acent-foreground)',
        fontWeight: 400,
    }),
    multiValue: (provided, state) => {
        let styleObj = {
            ...provided,
            display: 'flex',
            alignItems: 'center',
            backgroundColor: 'var(--accent)',
            color: 'var(--acent-foreground)',
            fontWeight: 600,
            borderRadius: '5px'
        }
        return styleObj
    },
    multiValueRemove: (provided, state) => {
        if (state.isDisabled) {
            return ({ ...provided, display: 'none' })
        } else {
            return ({ ...provided, color: 'var(--accent-foreground)', backgroundColor: 'transparent!important' })
        }
    },
    menu: (provided, state) => ({
        ...provided,
        marginTop: '0px',
        borderRadius: '2px 2px 15px 15px',
        boxShadow: '0 4px 11px hsla(0, 0%, 0%, 0.1)'
    }),
    menuList: (provided, state) => ({
        ...provided,
        padding: '0'
    }),
}

export const groupsMenuTheme = (theme) => ({
    ...theme,
    borderRadius: 0,
    colors: {
        ...theme.colors,
        primary25: 'var(--accent)',
        primary50: 'var(--accent)',
        primary: 'transparent',
        danger: 'var(--destructive)'
    },
})